import { effects } from 'redux-saga'
import { push as pushPath } from 'react-router-redux'

import setInitialClient from './setInitialClient'

export default function* advanceToAccount() {
  yield effects.fork(setInitialClient)

  yield effects.put.resolve(pushPath('/account'))

  yield effects.call(() => document.getElementById('wrapper').scrollIntoView())
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/advanceToAccount.js